import Axios from 'axios'
import store from '../store'
import strings from '@/strings'

const locker =  {
  getClientId () {
    return store.getters['Client/clientId']
  },
  getAvailableLockers () {
    return Axios.get(`/api/${strings.apiVersion.admin}/clients/${this.getClientId()}/lockers/names`)
  },
  findAvailableLockers (payload) {
    return Axios.get(`api/${strings.apiVersion.public}/clients/${this.getClientId()}/sites/${payload.siteId}/locations/${payload.locationId}/lockers-with-bookings?Start=${payload.start}&Finish=${payload.finish}&userEmail=${payload.userEmail}`)
  },
  getLockersByRegion (regionId) {
    return Axios.get(`api/${strings.apiVersion.admin}/clients/${this.getClientId()}/regions/${regionId}/lockers`)
  },
  getLockers (locationId) {
    return Axios.get(`api/${strings.apiVersion.admin}/clients/${this.getClientId()}/locations/${locationId}/lockers`)
  },
  getLocationsGroupedBySite () {
    return Axios.get(`api/${strings.apiVersion.admin}/clients/${this.getClientId()}/lockers/sites`)
  },
  relateLockersToRegion (relation) {
    return Axios.put(`api/${strings.apiVersion.admin}/clients/${this.getClientId()}/regions/${relation.regionId}/lockers`, relation.lockers)
  },
}

export default locker
